import { render, staticRenderFns } from "./CouponIssuePlanListIframe.vue?vue&type=template&id=72650be1&"
import script from "./CouponIssuePlanListIframe.vue?vue&type=script&lang=ts&"
export * from "./CouponIssuePlanListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports